$(function(){
	var sliderRecipe = [];
	var winW = $(window).width(),
		winH = $(window).height();

	$(window).on('resize', onResize);
	function onResize(){
		var winS_w = window.innerWidth;

			winW = $(window).width(),
		    winH = $(window).height();

		if(winS_w > 767){
			$('.recipe .worklists').each(function(i){
				var num = $(this).data('num');
				if( $(this).find('.slick-track').length ){
					sliderRecipe[num].slick('unslick');
				}
			});
		}else{
			$('.recipe .worklists').each(function(i){
				if( !$(this).find('.slick-track').length ){
					var num = $(this).data('num');
					slickslider_recipe(num,$(this));	
				}
			});		
		}
	}
	onResize();

	function slickslider_recipe(num,elm) {
		sliderRecipe[num] = elm.slick({
			centerMode: true,
			centerPadding: '15%',
			slidesToShow: 1,
			slidesToScroll: 1,
			accessibility: true,
			infinite: true,
			autoplay: true,
			dots:false,
			autoplaySpeed: 4000
		});
	}

	function slickslider_top() {
		$('#slider-conts .slider-list').slick({
			centerMode: true,
			centerPadding: ($(window).width() - 970) / 2,
			slidesToShow: 1,
			slidesToScroll: 1,
			accessibility: true,
			infinite: true,
			autoplay: true,
			dots:true,
			autoplaySpeed: 4000,
			responsive: [{
				breakpoint: 970,
				settings: {
					centerPadding: '10%',
				}
			},
			{
				breakpoint: 767,
				settings: {
					centerPadding: '0%',
				}
			}]
		});
	}
	slickslider_top();
});